// export type SidePanelKey = 'test' | 'step' | 'about' | 'options' | 'templates'
export type SidePanelKey = 'test' | 'about' | 'options' | 'templates' | 'modules'

export { default as TestingLab } from './TestingLab/TestingLab'
// export { default as SteppingLab } from './SteppingLab/SteppingLab'
export { default as Info } from './Info/Info'
export { default as Options } from './Options/Options'
export { default as Templates } from './Templates/Templates'
export { default as Modules } from './Modules/Modules'
